<template>
    <!-- 渲染颜色设置组件
        @author: liuguisheng
        @date: 2019-11-21
    -->
  <div class="setting-item">
    <el-form-item label="渲染颜色"> 
      <el-radio-group v-model="whereColor" size="small">
        <el-radio-button v-for="(item,index) in renderColorConfigList"
                         :key="index" 
                         :label="item.label">
                         {{item.value}}</el-radio-button>
        <div style="margin-top: 10px">
            <el-color-picker v-model="renderColor"></el-color-picker>
        </div>
      </el-radio-group>
    </el-form-item>
  </div>
</template>
<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
// 导入加粗配置文件
import { renderColorConfigList } from '@/assets/js/config_dictionary.js';
export default {
  mixins: [ mixValueWatch ],
  data () {
    return {
      // 加粗配置文件
      renderColorConfigList
    }
  },
  computed: {
    /** @name 渲染颜色设置
     *  @description 将 whereColor 字段映射到当前 whereColor 计算属性
     *  @return { Object }
     *  @author liuguisheng
     *  @version 2019-11-21
     */
    ...mapComputed({
      whereColor: { 
        parent: i => i.renderOption,
        attr: "whereColor" 
      },
    renderColor: { 
    parent: i => i.renderOption,
    attr: "renderColor" 
    }

    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/render_setting/RenderColor.vue